import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import Close from "@mui/icons-material/Close";
import ContentCopy from "@mui/icons-material/ContentCopy";
import FileDownload from "@mui/icons-material/FileDownload";
import FormatColorReset from "@mui/icons-material/FormatColorReset";
import RawOff from "@mui/icons-material/RawOff";
import RawOn from "@mui/icons-material/RawOn";
import Save from "@mui/icons-material/Save";
import { Alert, Box, Snackbar, Stack, Typography } from "@mui/material";
import { ActionBar, ActionBarItem } from "../../../../components/ActionBar/index.js";
import { useThemeActions } from "./useThemeActions.js";
function ThemeActions(props) {
  const { onOpenAdvancedSettingsModal, onClose } = props;
  const {
    themeName,
    handleDownload,
    handleOnCopyToClipboard,
    handleResetTheme,
    handleCloseSnackbar,
    snackBarOpen,
    pristine
  } = useThemeActions();
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(
      Box,
      {
        component: "header",
        "data-testid": "theme-actions-root",
        sx: (theme) => ({
          alignItems: "center",
          background: theme.vars.palette.background.default,
          display: "flex",
          justifyContent: "space-between",
          overflow: "hidden",
          paddingX: 1,
          paddingY: 1,
          width: "100%"
        }),
        children: [
          /* @__PURE__ */ jsxs(Stack, { direction: "row", sx: { overflow: "hidden", width: "100%" }, children: [
            /* @__PURE__ */ jsxs(Typography, { noWrap: true, variant: "h6", children: [
              themeName,
              pristine ? "" : "*"
            ] }),
            pristine ? /* @__PURE__ */ jsx(RawOn, { color: "success", fontSize: "large" }) : /* @__PURE__ */ jsx(RawOff, { color: "warning", fontSize: "large" })
          ] }),
          /* @__PURE__ */ jsxs(ActionBar, { menuMode: "iconOnly", size: "small", children: [
            /* @__PURE__ */ jsx(
              ActionBarItem,
              {
                icon: /* @__PURE__ */ jsx(FileDownload, {}),
                id: "download",
                label: "Download",
                mode: "menu",
                onClick: handleDownload,
                tooltip: "Download"
              }
            ),
            /* @__PURE__ */ jsx(
              ActionBarItem,
              {
                icon: /* @__PURE__ */ jsx(ContentCopy, {}),
                id: "copyToClipboard",
                label: "Copy to clipboard",
                mode: "menu",
                onClick: handleOnCopyToClipboard,
                tooltip: "Copy to clipboard"
              }
            ),
            /* @__PURE__ */ jsx(
              ActionBarItem,
              {
                icon: /* @__PURE__ */ jsx(FormatColorReset, {}),
                id: "delete",
                label: "Reset changes",
                mode: "menu",
                onClick: handleResetTheme,
                tooltip: "Reset changes"
              }
            ),
            /* @__PURE__ */ jsx(
              ActionBarItem,
              {
                icon: /* @__PURE__ */ jsx(Save, {}),
                id: "save",
                label: "Advances settings",
                mode: "menu",
                onClick: onOpenAdvancedSettingsModal,
                tooltip: "Advances settings"
              }
            ),
            onClose ? /* @__PURE__ */ jsx(ActionBarItem, { icon: /* @__PURE__ */ jsx(Close, {}), id: "close", label: "", mode: "end", onClick: onClose, tooltip: "Close" }) : /* @__PURE__ */ jsx("span", {})
          ] })
        ]
      }
    ),
    /* @__PURE__ */ jsx(Snackbar, { autoHideDuration: 5e3, onClose: handleCloseSnackbar, open: snackBarOpen, children: /* @__PURE__ */ jsx(Alert, { onClose: handleCloseSnackbar, severity: "error", sx: { width: "100%" }, children: "Failed to copy to clipboard" }) })
  ] });
}
export {
  ThemeActions
};
//# sourceMappingURL=ThemeActions.js.map
